import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MakeAxiosRequest } from "../../utils/handler";
import ListingPage from '../../Components/listing/ListingPage';
import TableContent from '../../Components/listing/TableContent';
import Loader from '../../Components/loader/Loader';
import { Link } from 'react-router-dom';
import newUser from '../../Assets/Images/newuser.png'
import welcome from '../../Assets/Images/welcome.png';
import ModalBox from '../../Components/modals/ModalBox';
import InvoiceDetails from '../Invoices/InvoiceDetails';
import { fetchNotificationCount, logout } from "../../features/authSlice";
import { useDispatch } from 'react-redux';
import noinvoice from '../../Assets/Images/newuserinvoice.png';
function Dashborad() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [data, setData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [showLoader, setShowLoader] = useState(false);
    const [loadingStatus, setLoadingStatus] = useState({ page: true, table: true });
    const [invoiceUuid, setInvoiceUuid] = useState('');
    const [invoice, setInvoice] = useState({});
    
    const [url, setUrl] = useState("");
    const [listParams, setListParams] = useState({
        page: 1,
        limit: 10,
    });
    const [modalShow, setModalShow] = useState(false);
    const handleClose = () => {
        setModalShow(false);
        };
        const handleShow = async(key) => {
        
        if(listParams.status == 'draft'){
            navigate('/invoices/edit/'+key)
        }else{

            try {
                const response = await MakeAxiosRequest("post", "/genaratewebtoken",{key:key,type:"invoicedetails"});
                if (response.status == 1) {
                    setUrl(response.data.redirectUrl);
                    setInvoiceUuid(key);
                    setModalShow(true);
                } else {
                    console.log(response);
                }
            } catch (error) {
                console.error("Error", error);
            }
            
        }

      };
    const fetchData = async () => {
        // setLoadingStatus({ page: true, table: true })
        try {
            const response = await MakeAxiosRequest("post", "gethomelist", listParams);
            // console.log(response)
            if (response.status == 1) {
                if(response.data.payment_connected == '0'){
                    
                    dispatch(logout());
                    navigate("/login");

                }
                setData(response.data);
                setInvoice(response.data.invoiceDetails);
                setIsLoading(false);
                setLoadingStatus({ page: false, table: false });
            } else {
                console.log(response);
            }
        } catch (error) {
            console.error("Error", error);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);
    const downloadInvoice = async (key) => {
        setShowLoader(true);
        try {
            const response = await MakeAxiosRequest("post", "/invoice/download", { invoice_uuid: key });

            if (response.status === 1) {
                if (response.data.base64Content) {
                    // Create a Blob from the base64 string
                    const byteCharacters = atob(response.data.base64Content);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: 'application/pdf' });

                    // Create a download link
                    const link = document.createElement('a');
                    const url = window.URL.createObjectURL(blob);
                    link.href = url;
                    link.setAttribute('download', response.data.invoiceNum + '.pdf'); // Customize the file name here
                    document.body.appendChild(link);
                    link.click();

                    // Clean up
                    link.remove();
                    window.URL.revokeObjectURL(url);
                    console.log('downloaded');
                    setShowLoader(false);
                }
            } else {
                console.log(response);
            }
        } catch (error) {
            console.error("Error", error);
        }
    };
    const handleRedirect = (path) => {
        navigate('/'+path); // Redirect to the invoices page
      };
    
    const columns = [
        {
            header: 'Invoice Number',
            type: 'click',
            isShow: true,
            className: 'table_item_group primary',
            clickFn:handleShow,
            data: {
                text: "invoice_number",
                key: "invoice_uuid",
            }
        },
        {
            header: 'Customer Name',
            type: 'text',
            isShow: true,
            className: 'table_item_group',
            data: {
                text: "first_name",

            }
        },
        {
            header: 'Invoice Date',
            type: 'date',
            className: 'numeric',
            isShow: true,
            data: {
                text: "invoice_date"
            }
        },
        {
            header: 'Amount',
            type: 'text',
            isShow: true,
            className: 'table_item_group',
            data: {
                text: "grand_total",
                textPrefix:"amountLabel"
            }
        },
        {
            header: 'Status',
            type: 'status',
            isShow: true,
            data: {
                text: "status",
            }
        },
        {
            header: 'Actions',
            type: 'actionBtns',
            isShow: true,

            buttons: [
                {
                    type: 'download',
                    key: 'invoice_uuid',
                    isShow: true,
                    function: downloadInvoice
                },
            ]
        }
    ];

    return (
        <>
            {isLoading ? (
                <Loader />
            ) : (

                <>
                    {invoice ? (
                        <>
                            <div className="row dashboardTop">
                                {/* <div className="col-12 col-lg-4 mb-3" onClick={()=>handleRedirect('invoices')}>
                                    <div className="card h-100">
                                        <div className="card-body dash-counts">
                                            <h5>Pending Payouts</h5>
                                            <h2 className="m-0">{data.payoutData.currencyLabel} {data.payoutData.pending_payout}</h2>
                                            <span>{data.payoutData.payout_txt}</span>
                                        </div>
                                    </div>
                                </div> */}
                                <div className="col-12 col-lg-6 mb-3" onClick={()=>handleRedirect('invoices')}>
                                    <div className="card h-100">
                                        <div className="card-body dash-counts">
                                            <h5>{data.invoiceData.label}</h5>
                                            <div className="invoiceDates">
                                                <div>
                                                    <h2 className="m-0">{data.invoiceData.unpaidCount}</h2>
                                                    <span>{data.invoiceData.unpaidLabel}</span>
                                                </div>
                                                <span></span>
                                                <div>
                                                    <h2 className="m-0">{data.invoiceData.paidCount}</h2>
                                                    <span>{data.invoiceData.paidLabel}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 mb-3" onClick={()=>handleRedirect('customers')}>
                                    <div className="card h-100">
                                        <div className="card-body dash-counts">
                                            <h5>{data.customerData.label}</h5>
                                            <h2 className="m-0">{data.customerData.customerCount}</h2>
                                            <span>{data.customerData.customer_txt}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <ListingPage
                                loadingStatus={loadingStatus.page}
                                setLoadingStatus={setLoadingStatus}
                                listParams={listParams}
                                setListParams={setListParams}
                                title="Recent Invoices"
                                totalCount={data.invoiceCount}
                                atag={<Link to="/invoices/create" className='btn btn-primary my-2'>Create Invoice</Link>}
                            >
                                <TableContent
                                    columns={columns}
                                    listingData={invoice}
                                    loadingStatus={loadingStatus.table}
                                    type="invoices"
                                    image={noinvoice}
                                />
                                {data.is_show_seemore == '1' && <div className='text-end'>
                                    <Link className='link' to="/invoices">View More</Link>
                                </div>}
                            </ListingPage>
                        </>
                        ) : (
                        <div>
                            <div className="row newdashboardTop">
                                <div className="col-12 mb-3">
                                    <div className="card flex-sm-row flex-column h-100">
                                        <img src={welcome} className="welcome-img" alt="Welcome" />
                                        <div className="card-body dash-counts text-sm-start text-center">
                                            <h2 className="m-0">Hello, {data.userData.name}</h2>
                                            <span>Welcome to Swizzle Pay</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-2">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row text-center justify-content-center">
                                                <div className="col-xx-5 col-xl-6 col-md-10 col-12">
                                                    <div className="newUserBody">
                                                        <img src={newUser} className="img-fluid" alt="New User" />
                                                        <h2>Create your first invoice</h2>
                                                        <h6 className="grey mb-4">A new invoice is made each minute in SwizzlePay</h6>
                                                        <Link to="/invoices/create" className="btn btn-primary w-50">Create Invoice</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                <ModalBox
                isShow={showLoader}
                className="close-btn"
                modalSize="md"
                hasData={true}
                >
                    <div className='row'> 
                        <Loader loaderclass=""/>
                        </div>
 
                </ModalBox>
                {modalShow && (
                    <InvoiceDetails
                        showModal={modalShow}
                        handleClose={handleClose}
                        invoiceKey={invoiceUuid}
                        url={url}
                    />
                )}
                </>
               
            )}

        </>
    )
}

export default Dashborad